import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HistoryMeta } from '../../helper/page-metadata';
import { CustomLabelService } from '../../services/custom-label/custom-label.service';

@Component({
    selector: 'app-history',
    template: `
        <app-list-layout-with-routing [Path]="PageMetaPath" [TabLabel]="(CustomerListLabel$ |async)">
            <app-customer-list></app-customer-list>

            <app-history-bookmarks
                *appListLayoutWithRoutingTab="'Lesezeichen'"
            ></app-history-bookmarks>
        </app-list-layout-with-routing>
    `,
    styles: [``],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HistoryComponent {
    PageMetaPath = HistoryMeta.Path;
    CustomerListLabel$: Observable<string> = this.cls.getSingle$('CustomerList');

    constructor(public cls: CustomLabelService) {
    }
}
